// extracted by mini-css-extract-plugin
export default {"root":"Hint__root--3KKOv","root_dark":"Hint__root_dark--_gylZ"};